/**
 * FAQ Data
 * Frequently asked questions data
 * 
 * @author Varun Pandey
 */

export interface FAQ {
  id: number;
  name: string;
  slug: string;
  content: string;
  value: string;
  created_at: string;
  updated_at: string;
}

export const faqData: FAQ[] = [
  {
    "id": 1,
    "name": "General Query",
    "slug": "general-query",
    "content": "What is StarClinch?",
    "value": "StarClinch is a platform that connects talented artists with event organizers and clients, helping to create meaningful relationships and unforgettable experiences. It’s not just about booking gigs—it’s about fostering connections that bring magic to every event.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 2,
    "name": "General Query",
    "slug": "general-query",
    "content": "How does StarClinch work for artists?",
    "value": "StarClinch provides artists with personalized websites to showcase their talent, connect with clients, and access diverse gig opportunities. The platform ensures smooth negotiations and fosters a thriving artistic community.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 3,
    "name": "General Query",
    "slug": "general-query",
    "content": "Why become a paid member?",
    "value": "While signing up on StarClinch is free, becoming a paid member unlocks exclusive benefits to boost your career:\nProfessional Profile: Get a professionally written profile to captivate clients.\nBoosted Visibility: Enjoy SEO-friendly profiles, priority in search results, and enhanced client pitches.\nAccess Opportunities: Apply to daily job postings and maximize your chances of bookings.\nAdvanced Tools: Showcase your talent with integrated bios, photos, and videos, and track your performance with analytics.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 4,
    "name": "General Query",
    "slug": "general-query",
    "content": "Is there a fee for artists who want to join StarClinch?",
    "value": "Signing up is free, but upgrading to a Membership Plan unlocks valuable perks like enhanced visibility, SEO-friendly profiles, priority support, promotions, and analytics tools. These plans help boost your exposure and success in the competitive entertainment industry, giving you the resources to grow your career and achieve your goals. ",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 5,
    "name": "General Query",
    "slug": "general-query",
    "content": "What types of artists can join StarClinch?",
    "value": "StarClinch welcomes artists from various creative fields, including musicians, singers, dancers, DJs, comedians, magicians, actors, anchors/emcees, makeup artists, stylists, models, speakers, and more. Whatever your talent, you can showcase it on our platform!",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 6,
    "name": "General Query",
    "slug": "general-query",
    "content": "What types of events can I find on StarClinch?",
    "value": "StarClinch offers gigs for weddings, corporate events, charity events, private parties, music festivals, kids' parties, exhibitions, and more. Whatever the occasion, we have the perfect entertainment for you!",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 7,
    "name": "General Query",
    "slug": "general-query",
    "content": "How does StarClinch ensure artist quality?\n",
    "value": "StarClinch follows a strict screening process, verifying credentials, reviewing previous work, and monitoring client feedback to ensure only talented and professional artists join the platform.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 8,
    "name": "General Query",
    "slug": "general-query",
    "content": "What if I have a question or need assistance while using StarClinch?",
    "value": "Our customer support team is available to assist you with any questions or concerns you may have. You can reach out to us at connect@starclinch.com and we'll be happy to help you.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 9,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "Why sign up on StarClinch?",
    "value": "Signing up on StarClinch is free and opens doors to endless opportunities! Create your own mini website to showcase your videos, photos, biographies, and preferred events – all in one place. This link is pitched to clients and can be shared with your network to highlight your work.\nWith StarClinch, you get:\nA global platform to promote your talent.\nAn easy-to-use Artist Dashboard to manage your profile, bookings, and pricing.\nTools to import content from social media and track profile performance with Google stats.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 10,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "What is TAF, and why is it charged?",
    "value": "TAF (Technology Aggregation Fee) is a platform handling charge of up to 25% for the technological services and convenience that StarClinch provides. This fee helps cover platform operations, lead generation, client management, and secure booking support, ensuring a smooth and transparent experience for artists.\n\nPlease note that the TAF may vary based on your profile category and activity on the platform. Upgrading to a StarClinch membership (such as Premium or Elite) can help reduce this fee, along with unlocking additional benefits like better visibility and higher-quality booking opportunities.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 11,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "Can I contact the event organizer directly?",
    "value": "StarClinch connects artists with clients securely. Once a booking is confirmed, artists can contact the client directly, ensuring smooth communication and a professional experience. Our platform supports successful bookings with dedicated assistance throughout.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 12,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "How can I delete my profile?",
    "value": "To remove your profile, report it to us, and we’ll guide you through the verification process for deletion. Alternatively, email us at connect@starclinch.com, and we’ll assist you promptly.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 13,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "How will I get paid?",
    "value": "Simply add your bank details in the Artist Cockpit. StarClinch collects the full payment from the client before the event. After the event, the amount (minus TAF and applicable TDS) is securely transferred to your account through our escrow system.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 14,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "What are my chances of getting gigs from StarClinch?",
    "value": "StarClinch generates 5,000+ monthly opportunities for its 35,000+ registered artists across India. Keeping your profile updated with quality content, videos and accurate details boosts your chances of getting hired. StarClinch Membership further enhances your visibility and booking opportunities.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 15,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "What is the minimum age to join StarClinch?",
    "value": "There’s no age limit to create an account, but artists under 18 require parental consent to join.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 16,
    "name": "For Artists",
    "slug": "for-artists",
    "content": "What happens if I cancel or fail to show up for a confirmed booking?\n",
    "value": "Once a booking is confirmed, it cannot be canceled without mutual agreement. The artist must refund the advance payment to the client or through StarClinch. Failure to comply may lead to profile removal and liability for service and penalty fees as per the agreement. Non-compliance may result in account termination.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 17,
    "name": "Sign-Up",
    "slug": "sign-up",
    "content": "Who can sign up on StarClinch?",
    "value": "Professional artists from any of StarClinch's 15 talent categories can register, provide relevant details, and create a profile to go live and get discovered.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 18,
    "name": "Sign-Up",
    "slug": "sign-up",
    "content": "What talent categories are available on StarClinch?",
    "value": "StarClinch offers a diverse range of talent categories, including Live Band, Singer, Celebrity, Comedian, Anchor/Emcee, DJ, Dancer, Instrumentalist, Magician, Makeup Artist, Model, Photographer, Speaker, and Variety Artist.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 19,
    "name": "Sign-Up",
    "slug": "sign-up",
    "content": "Can I sign up on StarClinch if I’m just starting my career?",
    "value": "Yes! StarClinch welcomes artists at all stages. Beginners can sign up and create a complete profile to go live. It’s a great platform to showcase your talent, connect with clients, and kickstart your career.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 20,
    "name": "Sign-Up",
    "slug": "sign-up",
    "content": "Why Add social links?",
    "value": "Adding social links verifies your identity and speeds up profile approval. While optional at registration, providing at least one link is recommended for verification.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 21,
    "name": "Sign-Up",
    "slug": "sign-up",
    "content": "What’s needed to register as an artist?",
    "value": "A valid email address and an Indian phone number are required to sign up.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 22,
    "name": "Sign-Up",
    "slug": "sign-up",
    "content": "What should be my “Profile Picture” size and dimension?",
    "value": "Upload an image under 1 MB with 4:5 dimensions (1080x1350px). Use the cropping tool to adjust as needed.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 23,
    "name": "Login Page",
    "slug": "login",
    "content": "How can I log into the StarClinch cockpit?",
    "value": "Log in easily via\nRegistered email and password\nFacebook\nGoogle\nEnsure the email linked to Facebook or Google matches your StarClinch profile.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 24,
    "name": "Login Page",
    "slug": "login",
    "content": "How to change your profile picture:",
    "value": "Open the 'Home' section in your artist dashboard.\nClick 'Change Image' and upload a new picture from your device.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 25,
    "name": "Login Page",
    "slug": "login",
    "content": "I Have forgotten my password. How can I retrieve It?",
    "value": "Forgot your password? Follow these steps:\nClick on \"Forgot Password?\" on the login page.\nEnter your registered mobile number or email.\nClick \"Reset Password\" and verify with the OTP sent to you.\nSubmit the OTP to reset your password.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 26,
    "name": "Login Page",
    "slug": "login",
    "content": "I am unable to log in.",
    "value": "Use the correct email and password. If forgotten, click \"Forgot Password\" to reset it.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 27,
    "name": "Login Page",
    "slug": "login",
    "content": "What is the 'Complete Profile' Section, and why is it Important?",
    "value": "The 'Complete Profile' section shows how much of your profile is complete. A 100% profile ensures you appear in relevant job listings and can bid for jobs using SC Coins.\nTo reach 100%, fill out 17 key sections like:\nUSP, Biography, Pricing, Performance Details\nContact Verification (Email, Phone)\nGallery, Videos/Audio, Profile Picture\nLocation, Genre, Travel, Language, and Tech Rider\nCompleting your profile improves your chances of getting hired.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 28,
    "name": "Login Page",
    "slug": "login",
    "content": "What is 'Get Gigs'?",
    "value": "'Get Gigs' directs you to the 'Job' section, where paid members can view and bid on jobs tailored to their profile and genre using SC Coins. Free members cannot access this section.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 29,
    "name": "Login Page",
    "slug": "login",
    "content": "Quick and comprehensive tools accessible through your \"Home\" section:",
    "value": "The 'Home' section shows:\nProfile completion percentage\nProfile views and time spent by visitors\nInterest and shortlist stats\nYou can also:\nUpdate your profile picture\nAccess Gallery, Videos, Audio, Biography, and Key Info \nExplore job listings via 'Get Gigs'\nStats are visible to paid, verified members. Consider our affordable membership plans for premium perks.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 30,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How can I upload pictures and videos to my profile?",
    "value": "-Log in to your Artist cockpit\n-Go to the profile editing section\n-Now go to the Gallery section upload your photos and add links of your videos from your Instagram YouTube and other platforms. ",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 31,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Can I link my social media accounts to my profile?",
    "value": "COMING SOON",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 32,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Which social media accounts can I link to my StarClinch profile?",
    "value": "COMING SOON",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 33,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How do I add YouTube videos?",
    "value": "We have two options for adding YouTube videos- \n\nOption 1:\nGo to edit profile > Gallery > Videos > Click on the link icon > Paste the Youtube video links one by one > Click on “Add Link” > Upload all links. \n\nOption 2:\nGo to edit profile > Gallery > Videos > Click on the YouTube icon > Search channel name > Select your channel > Select the video you want to add",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 34,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Is there a limit on uploading media?",
    "value": "Yes, You can upload multiple files, but ensure they meet size and format requirements it also depends on the membership plan.  Contact support for issues at connect@starclinch.com",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 35,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Do clients have access to view my linked social media accounts from my StarClinch profile?",
    "value": "No, clients typically do not have direct access to view your linked social media accounts from your StarClinch profile. Instead, they will be able to view all the pictures that you have imported from your social media on the Gallery.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 36,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "What should I include in the \"Unique Selling Points\" (UPS) section of my profile?\n",
    "value": "The Unique Selling Points section allows you to highlight what sets you apart from other artists. You can include information about your unique talents, skills, performance style, or anything else that makes you stand out in the industry. ",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 37,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How long should my \"Tell us your story\" section be?",
    "value": "Your story has a minimum of 100 words. We recommend keeping it concise while providing enough detail to give clients insights into your background, journey, and passion for your art.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 38,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Can I mention specific performances in the \"Performance\" section?",
    "value": "Yes, you can mention specific performances that you're proud of in this section. Whether it's a notable venue you've performed at, a memorable event you've been part of, or a significant project you've contributed to, feel free to highlight your key performances.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 39,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "What kinds of achievements, awards, and honors should I include in my profile?",
    "value": "Include any achievements, awards, or honors that showcase your talent, professionalism, and recognition within your industry. This could include awards for best performance, nominations, accolades from reputable organizations, or any other notable achievements.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 40,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Can I update or edit the information in my Biography section after I've initially filled it out?",
    "value": "Yes, you can edit and update the information in your Biography section at any time through your profile editing settings. Feel free to make adjustments as your career progresses, or whenever you have new achievements or updates to share.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 41,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How can I make my biography section stand out to potential clients?",
    "value": "To make your Biography section stand out, be authentic, passionate, and detailed in showcasing your unique talents, experiences, and achievements. Highlight what makes you a valuable asset to clients and why they should choose you for their events or gigs.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 42,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How do I select the right genre for my profile?",
    "value": "When creating your profile, select the genre(s) that best represent your field of performance from the dropdown list provided. It's important to choose genres that accurately reflect your profession to attract the right clients and opportunities.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 43,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How should I choose my preferred events?",
    "value": "In the \"Events Preferred\" section, click \"Events and Pricing\" which will open up a new page, and click “Edit” to select the events you're interested in performing at. Check the boxes next to the events that align with your expertise and preferences, and mention your discounted pricing where applicable.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 44,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Am I open to traveling for performances?",
    "value": "In the \"Open to Travel\" section, indicate whether you're willing to travel pan India for performances by selecting \"Nationwide\" or \"No\" from the dropdown menu. This helps us match you with gigs that require artists willing to travel.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 45,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Can I specify my preferred performance language(s)?",
    "value": "Yes, you can select your preferred performance language(s) from the dropdown menu provided. This ensures that clients looking for artists who can perform in specific languages can easily find you.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 46,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "What should I do if I have off-stage members, such as makeup artists or sound technicians?",
    "value": "If you have off-stage members, Follow the steps below-\n\nGo to profile section > Performance > Add members name and role in performing section.\n\n. If you're a solo artist and don't have any off-stage members, Skip add members part.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 47,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "What should I mention in the performance duration section?\n",
    "value": "Specify the minimum and maximum duration you're able to perform in minutes. This helps clients plan their events and ensures that you're booked for the appropriate length of time. ",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 48,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "Can I edit the price range for my performances?",
    "value": "The price range displayed is based on the information provided in the Events & Pricing page. You can further edit or adjust the price range from the Events & Pricing page to accurately reflect your rates and preferences.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 49,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How does a professionally written biography help?",
    "value": "Our trained content writers craft biographies that effectively showcase your services in a relevant manner. We incorporate high-ranking keywords to enhance your visibility on popular search engines.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 50,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "What kind of images can be uploaded to the gallery? ",
    "value": "You can upload images in JPG and PNG file formats from your PC or device. The maximum upload limit is 1 MB each.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 51,
    "name": "Edit Profile",
    "slug": "edit-profile",
    "content": "How to Import Images from Instagram?",
    "value": "Click the Instagram icon in the gallery.\nLog in to your Instagram account.\nSelect images to import.\nPreview your selection, modify it if needed, and press \"Import\" to complete the process.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 52,
    "name": "Events & Pricing",
    "slug": "events-pricing",
    "content": "What is the “Event & Pricing” section for? How can a user add their preferred events and pricing?\n",
    "value": "The \"Event & Pricing\" section allows artists to update the events they are willing to perform for, choose from pre-listed options, and specify their pricing. This section is vital as it provides crucial information to StarClinch for recommending the artist to clients. To add preferred events and pricing, simply click on \"Edit,\" select the desired events, and input the corresponding charges in the \"Discounted Pricing\" field. Please note that mentioning the \"Discounted Pricing\" is mandatory to save this section.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 54,
    "name": "Events & Pricing",
    "slug": "events-pricing",
    "content": "Can I add or delete the events listed on the \"Events & Pricing\" section?",
    "value": "Yes, artists have the flexibility to add or delete events as needed. However, it's important to select events that the artist is fully comfortable performing. Selecting events that the artist isn't certain about may lead to wasted time and irrelevant job notifications. It's advisable to ensure that the events chosen align with the artist's preferences to optimize job listings in the \"Job\" section.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 55,
    "name": "Performance Details",
    "slug": "performance-details",
    "content": "What is a Tech Rider, and do I need to provide one for my performance?",
    "value": "A Tech Rider outlines the technical requirements necessary for your performance, including sound, stage, lighting, and equipment. If you have specific technical requirements, you can request a Tech Rider by selecting \"Yes\" in the corresponding switch. Otherwise, you can choose \"No\" if you have minimal requirements or don't require any technical specifications.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 56,
    "name": "Performance Details",
    "slug": "performance-details",
    "content": "What should I include in my Tech Rider if I choose to request one?\n",
    "value": "If you require a Tech Rider for your performance, it's important to mention only the bare minimum technical requirements necessary for your setup. This helps us arrange the necessary equipment and manage the budget effectively.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 57,
    "name": "Performance Details",
    "slug": "performance-details",
    "content": "Do I need to provide details for my travel, boarding, and lodging performance?",
    "value": "If your performance requires inter-city travel and you need Travel, Boarding, and Lodging facilities, you can select \"Yes\" in the corresponding switch. Otherwise, choose \"No\" if you don't require these accommodations.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 58,
    "name": "Performance Details",
    "slug": "performance-details",
    "content": "What information should I include in my Travel, Boarding, and Lodging (TBL) details?\n",
    "value": "If you choose to request Travel, Boarding, and Lodging facilities, please mention only the bare minimum requirements necessary for your comfort during inter-city travel. This helps us arrange suitable accommodations while managing costs effectively.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 59,
    "name": "Performance Details",
    "slug": "performance-details",
    "content": "Can I specify any special requests or preferences for Travel, Boarding, and Lodging?",
    "value": "While providing TBL details, you can include any special requests or preferences you may have regarding travel arrangements, accommodation amenities, dietary restrictions, or other relevant considerations. We'll do our best to accommodate your needs within reason.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 60,
    "name": "Performance Details",
    "slug": "performance-details",
    "content": "Can I specify any special requests or preferences for Travel, Boarding, and Lodging?",
    "value": "While providing TBL details, you can include any special requests or preferences you may have regarding travel arrangements, accommodation amenities, dietary restrictions, or other relevant considerations. We'll do our best to accommodate your needs within reason.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 61,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Benefits of joining a StarClinch membership plan",
    "value": "Professional Website: A professionally written website description to enhance your presentation.\nDedicated Manager: Personalized support from a dedicated profile manager.\nIncreased Visibility: Blog features, boosted pitches, and SEO services to maximize your reach.\nPremium Support: Priority email and chat support for quick assistance.\nWeb Tools: Advanced tools to enhance your online presence and attract more inquiries.\nThese benefits are designed to help you grow your career in the entertainment industry.\n(membership details)",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 62,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Do you offer a free trial on membership plans?",
    "value": "No, we don’t offer a free trial, but our starter plan is available at INR1199 (Quarterly) and INR 2999 (yearly). You can upgrade anytime, and the paid amount will be adjusted.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 63,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What are the different membership plans available, and what distinguishes them?",
    "value": "StarClinch offers three membership plans: Economy, Premium, and Elite. Each plan offers varying levels of benefits and services, with Elite typically offering the most comprehensive and premium features, followed by Premium and Economy. (provide link to direct them towards membership plans)",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 64,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Can I upgrade my existing membership plan?",
    "value": "Yes, you can upgrade your membership Plan, and the amount you’ve already paid will be adjusted (excluding GST).\n For example, if you upgrade from Economy to Elite halfway through the year, you’ll pay INR 19,999        \n minus INR 1,244, and your membership will be extended for another year.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 65,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Can I downgrade my membership plan?",
    "value": "No, membership plans cannot be downgraded. We ensure all members receive top-tier features and support for maximum value.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 66,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Can I get a refund of my membership fee?",
    "value": "Membership fees are non-refundable. StarClinch’s annual plans cover the costs of creating your dedicated page and providing listed benefits. We appreciate your understanding.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 67,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Do I have to pay upfront for Membership Plans, and are they renewable? ",
    "value": "Yes, StarClinch Membership Plans require upfront payment to enjoy the perks and benefits. These plans are typically renewable on an annual basis.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 68,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Can you explain the benefits of a professionally written profile description?",
    "value": "A professionally written profile description enhances your online presence, highlighting your talent and experience, which increases your chances of securing bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 69,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What is a dedicated profile manager, and how can they assist me?",
    "value": "A dedicated profile manager offers personalized support, helping optimize your profile and maximize membership benefits.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 70,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "How many boosted pitches per month do I get with each membership plan?",
    "value": "The number of boosted pitches per month depends on your membership plan. Elite offers the most, followed by Premium and Economy, increasing your chances of securing bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 71,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What kind of support can I expect with StarClinch Membership Plans?",
    "value": "StarClinch membership plans provide priority email and chat support, with exclusive high-priority call support for top-tier plans, ensuring personalized assistance whenever needed.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 72,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What is SC Coin and what is it used for?",
    "value": "SC Coins are utility tokens provided with membership plans, used by artists to bid on gigs listed in the dashboard. They act as passes indicating interest in specific jobs.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 73,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "How many SC Coins are required for bidding on each job? ",
    "value": "To bid on a job, you'll need 50 SC Coins.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 74,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Is it guaranteed that an artist will get the job once they bid for it? ",
    "value": "No, getting a job isn't guaranteed. StarClinch informs clients of interested artists, but the\nclient selects based on preferences like budget, location, and language.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 75,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Will my SC Coins be refunded if I don't get the job after bidding?",
    "value": "No, SC Coins are non-refundable, even if you don't win the bid for a job.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 76,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What kind of Analytics + Profile Insights will I get from my membership plans?",
    "value": "Profile Metrics:\n\nKeep track of important metrics like Profile Views, Minutes Spent on Profile, and Profile Interest percentage.\n\nGraphical Insights:\n\nVisualize your performance over time with comprehensive graphs, including:\nTotal Users on Profile (monthly bar graph)\nProfile Views (monthly line graph)\nImpressions on Profile (monthly bar graph)\nTotal Deals (monthly bar graph)\nTotal Pitch Count (monthly bar graph)\nViews on Overall Category (monthly bar graph)\n\nAudience Understanding:\n\nUnderstand your audience better with detailed breakdowns such as:\nProfile Views by City (pie chart)\nProfile Views by Device (mobile, desktop, tablet - pie chart)\nProfile Views by Source (Google/Organic, direct, referral sources - pie chart)\n\nThese insights provide invaluable information to help you optimize your profile and maximize your opportunities!\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 77,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What are boosted pitches, and how many do I receive per month in the Quarterly and Yearly plan?",
    "value": "Boosted pitches enhance your visibility and booking chances for events. StarClinch recommends you to clients matching your profile, exclusively for paid members:\nEconomy: 2 pitches/month\nPremium: 5 pitches/month\nElite: 10 pitches/month\nThese pitches boost exposure and booking opportunities, supporting career growth. \n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 78,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What are paid campaigns on search engines in StarClinch's membership plans?",
    "value": "COMING SOON",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 79,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "How many paid PPC campaigns do I receive per month with the SC Black membership plan?",
    "value": "COMING SOON",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 80,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "What benefits do the paid PPC campaigns offer?",
    "value": "COMING SOON",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 81,
    "name": "Membership Plans",
    "slug": "membership-plans",
    "content": "Does StarClinch offer SEO services for artist profiles?\n",
    "value": "Yes, StarClinch offers SEO services to optimize artist profiles for maximum visibility. Paid membership plans include expert-written profile descriptions and a Dedicated Profile Manager to enhance SEO and boost client engagement and bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 82,
    "name": "My stats",
    "slug": "my-stats",
    "content": "What is the \"My Stats\" section on the artist dashboard?",
    "value": "The \"My Stats\" section on the artist cockpit is a feature available exclusively to paid membership artists. It provides comprehensive insights into the performance of your StarClinch profile, allowing you to track key metrics and understand how your profile is generating interest on the platform.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 83,
    "name": "My stats",
    "slug": "my-stats",
    "content": "What kind of stats are displayed in the \"My Stats\" section?",
    "value": "The \"My Stats\" section displays a range of important metrics to give you an overview of your profile's performance. \n\nTotal users on profile (monthly bar graph)\nProfile views (monthly line graph)\nImpressions on profile (monthly bar graph)\nTotal deals (monthly bar graph)\nTotal pitch Count (monthly bar graph)\nViews on overall category (monthly bar graph)\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 84,
    "name": "My stats",
    "slug": "my-stats",
    "content": "Can I filter the graphical stats in the \"My Stats\" section?",
    "value": "Yes, you can filter the graphical stats to view data for specific time periods. You have the option to filter the data for either the last 7 days or the last 30 days, providing you with insights into recent performance trends.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 85,
    "name": "My stats",
    "slug": "my-stats",
    "content": "How can the \"My Stats\" section help me improve my profile?",
    "value": "By analyzing the data provided in the \"My Stats\" section, you can identify trends, understand user behavior, and make informed decisions to optimize your profile for better performance. This insight can help you tailor your profile content, adjust your promotional strategies, and ultimately increase your visibility and success on StarClinch.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 86,
    "name": "My stats",
    "slug": "my-stats",
    "content": "How often is the data in the \"My Stats\" section updated?",
    "value": "The data in the \"My Stats\" section is updated regularly to provide you with real-time insights into your profile's performance. You can expect the data to be refreshed periodically to reflect the latest activity on your profile.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 87,
    "name": "My stats",
    "slug": "my-stats",
    "content": "Can I export or download the data from the \"My Stats\" section for further analysis?",
    "value": "Currently, there isn't an option to export or download the data directly from the \"My Stats\" section. However, you can manually record or screenshot the information for your records or further analysis.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 88,
    "name": "My stats",
    "slug": "my-stats",
    "content": "Is the data in the \"My Stats\" section accessible to anyone else, such as clients or other artists?",
    "value": "No, the data in the \"My Stats\" section is private and only visible to you as the profile owner. It is not accessible to clients or other artists on StarClinch.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 89,
    "name": "My stats",
    "slug": "my-stats",
    "content": "Can I track the performance of specific content, such as videos or photos, in the \"My Stats\" section?",
    "value": "Currently, the \"My Stats\" section provides overall performance metrics for your profile as a whole. However, you can track the performance of specific content, such as videos or photos, by analyzing the data provided in the section and observing trends over time.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 90,
    "name": "My stats",
    "slug": "my-stats",
    "content": "How can I use the insights from the \"My Stats\" section to improve my profile's performance?",
    "value": "The insights from the \"My Stats\" section can help you identify areas of strength and areas for improvement in your profile. Use this information to refine your content, adjust your promotional strategies, and optimize your profile for better visibility and engagement.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 91,
    "name": "Jobs",
    "slug": "jobs",
    "content": "How do I access the \"Jobs\" section on my artist dashboard? ",
    "value": "The \"Jobs\" section can be accessed directly from your artist dashboard after logging into your StarClinch account. Simply navigate to the \"Jobs\" tab to view all available job opportunities relevant to your genre and preferences.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 92,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Will I be able to view the listed jobs in the \"Jobs\" section if I'm not a paid member?",
    "value": "All members can view and apply for jobs once their profile is 100% complete, live, and they have enough coins.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 93,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Are the jobs listed in the \"Jobs\" section tailored to my skills and preferences?",
    "value": "Yes, the jobs listed in the \"Jobs\" section are personalized based on the genre and details provided in your profile. To ensure you receive personalized job recommendations, it's essential to complete your profile to 100%",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 94,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Can I view detailed information about each job listed in the \"Jobs\" section?",
    "value": "Absolutely! Each job listing includes important details such as the date, audience size, location, and budget. You can also click on the \"More details\" link to view comprehensive information about the job uploaded by the client.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 95,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Can I view detailed information about each job listed in the \"Jobs\" section?",
    "value": "Absolutely! Each job listing includes important details such as the date, audience size,   \n          location, and budget. You can also click on the \"More details\" link to view comprehensive            information about the job uploaded by the client.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 96,
    "name": "Jobs",
    "slug": "jobs",
    "content": "How do I bid for a job listed in the \"Jobs\" section?",
    "value": "To bid for a job, simply click the \"Apply Now\" button on the job listing. Please note that each job application consumes 50 SC Coins, which will be deducted from your total SC Coins. Make sure you have enough SC Coins before applying for a job.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 97,
    "name": "Jobs",
    "slug": "jobs",
    "content": "How can I keep track of the jobs I've applied for?",
    "value": "You can easily keep track of the jobs you've applied for using the \"Active\" and \"Applied\" buttons. The \"Active\" button filters the jobs you're currently actively considering, while the \"Applied\" button shows the jobs you've already applied for.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 98,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Can I filter the jobs listed in the \"Jobs\" section based on specific criteria? ",
    "value": "Currently, the \"Jobs\" section does not offer filtering options. However, you can manually review the job listings and prioritize based on your preferences and availability.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 101,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Is it guaranteed that I will get the job after applying for it?",
    "value": "No, it is not guaranteed that you will get the job after applying. The final decision lies with the client, who will select the artist among all the applicants based on their preferences and requirements.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 102,
    "name": "Jobs",
    "slug": "jobs",
    "content": "How do I know if my application for a job has been successful?",
    "value": "If your application for a job is successful, you will be notified by StarClinch via email or through the notifications section on your artist dashboard. You may also receive further communication from the client regarding the details of the job.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 103,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Can I withdraw my application for a job after applying?",
    "value": "No, once you have applied for a job, you cannot withdraw your application. Make sure to apply only for the jobs that you are genuinely interested in and available for.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 104,
    "name": "Jobs",
    "slug": "jobs",
    "content": "Can I apply for multiple jobs at the same time?",
    "value": "Yes, you can apply for multiple jobs simultaneously. However, keep in mind that each job application will consume 50 SC Coins, so make sure you have enough coins available in your account.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 105,
    "name": "Wallet",
    "slug": "wallet",
    "content": "What is the purpose of the Wallet section?",
    "value": "The Wallet section allows users to manage their SC Coins balance, which is used for bidding on jobs to secure gigs on StarClinch.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 106,
    "name": "Wallet",
    "slug": "wallet",
    "content": "How can I top up my SC Coins balance?",
    "value": "To top up your SC Coins balance, simply navigate to the Wallet section and choose the desired amount of SC Coins you wish to purchase. You can either select a predefined amount or enter a custom amount.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 107,
    "name": "Wallet",
    "slug": "wallet",
    "content": "Can both paid and free members purchase SC Coins?",
    "value": "Yes, both paid and free members have the option to purchase SC Coins from the Wallet section. SC Coins are essential for bidding on jobs to secure gigs on the platform.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 108,
    "name": "Wallet",
    "slug": "wallet",
    "content": "How do I check my SC Coins balance?",
    "value": "You can view your SC Coins balance directly in the Wallet section of your artist dashboard. Your current balance will be displayed prominently for easy reference.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 109,
    "name": "Wallet",
    "slug": "wallet",
    "content": "Are there any discounts available for purchasing SC Coins?",
    "value": "Yes, becoming a paid member qualifies you for discounts when buying SC Coins. The percentage of discount varies depending on the membership plan you choose.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 110,
    "name": "Wallet",
    "slug": "wallet",
    "content": "Can I use StarCoins for purposes other than bidding on jobs?",
    "value": "SC Coins are primarily used for bidding on jobs to secure gigs on StarClinch. At the moment, they cannot be used for any other purposes on the platform.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 111,
    "name": "Wallet",
    "slug": "wallet",
    "content": "Is there a limit to the number of SC Coins I can purchase at once?",
    "value": "No, there is no limit to the number of SC Coins you can purchase at once. You have the flexibility to choose the desired amount based on your bidding needs.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 112,
    "name": "Wallet",
    "slug": "wallet",
    "content": "Can I transfer SC Coins to other artists or members?",
    "value": "Currently, SC Coins cannot be transferred between users. Each artist's SC Coins balance is independent and can only be used for their own bidding activities.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 113,
    "name": "Wallet",
    "slug": "wallet",
    "content": "What is the value of 1 SC Coin?",
    "value": "Each SC Coin holds a value of 1 Indian Rupee (INR). Artists can use SC Coins to bid on jobs and acquire gigs through the StarClinch platform.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 114,
    "name": "Wallet",
    "slug": "wallet",
    "content": "What is the \"Add Coin\" tab in the wallet section for?",
    "value": "The \"Add Coin\" tab allows artists to top up their SC Coin balance by purchasing additional SC Coins. You can select a custom amount or choose from predefined amounts like 500, 1000, 2000, and 4000 SC Coins.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 115,
    "name": "Wallet",
    "slug": "wallet",
    "content": "What is the \"Recent Transaction\" tab for in the Wallet section?",
    "value": "The \"Recent Transaction\" tab displays a record of your most recent transactions related to SC Coins. You can view details such as the date, time, transaction type, and the amount of SC Coins involved in each transaction. This feature helps you keep track of your SC Coin usage and top-ups.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 116,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "What are billing details, and why are they essential to fill?",
    "value": "Billing details are crucial information required to ensure prompt and accurate payment processing for your performances. It includes vital details such as:\n\nAccount Holder Name: The name of the account holder where you want your performance fee transferred.\nBank Name: The name of your bank.\nAccount Number: Your bank account number.\nAccount Type: Specify whether it's a savings account or a current account.\nBank Branch & Address: The branch and address of your bank.\nIFSC Code: This unique code enables online transfers (NEFT).\nPAN: Your Permanent Account Number, required for tax purposes.\nGSTIN: If applicable, provide your GST Identification Number.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 117,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "How long does it take to verify billing details, and how will I know if they are correct?",
    "value": "It typically takes around 3-4 days for our team to verify your billing details. Once confirmed, you will receive a confirmation message indicating that the information provided is accurate and verified.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 118,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "How can I ensure that the billing details I've entered are accurate?",
    "value": "Before saving your billing details, double-check all the information you've entered to ensure accuracy. Once you're certain that everything is correct, simply press the \"Save\" button to save the entered information.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 119,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "How will I receive my payment after a successful performance?",
    "value": "Once the job is confirmed, StarClinch will guide you through the process of signing contracts outlining the requirements and payment terms set by the client. After the performance is successfully completed and verified, payments will be processed according to the terms agreed upon in the contract. Your earnings will then be transferred directly to the bank account provided in your billing details.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 120,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "Is it mandatory to fill out all the fields in the billing details form?",
    "value": "Yes, it's essential to fill out all the required fields accurately to ensure smooth payment processing. Incomplete or inaccurate information may result in delays or complications in receiving your payment.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 121,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "Will my billing details be kept secure and confidential?",
    "value": "Yes, we prioritize the security and confidentiality of your billing details. Your information will be encrypted and stored securely to prevent unauthorized access or misuse.\n",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 122,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "What should I do if there's an issue with my payment or billing details?",
    "value": "If you encounter any issues related to payment or billing details, please reach out to our support team for assistance. They will guide you through the resolution process and ensure that your concerns are addressed promptly. (email)",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 123,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "What information can I find in the Contact Details section?",
    "value": "The Contact Details section contains essential information such as your name, email address, and phone number.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 124,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "Why is it important to verify my email and phone number?",
    "value": "Verifying your email and phone number is crucial to ensure the security of your account and to receive important notifications and updates regarding your profile and bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 125,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "How can I verify my email and phone number?",
    "value": "To verify your email and phone number, click on the \"Verify your Email\" or \"Verify your Number\" link in red letters, respectively. You will receive an OTP (One-Time Password) via email and SMS, which you'll need to enter in the pop-up box labeled \"Enter OTP\" and click submit.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 126,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "What happens after I enter the OTP to verify my email or phone number?",
    "value": "Once you enter the OTP and submit it, your email or phone number will be successfully verified. The word \"verified\" will appear in the bottom-right corner of the respective box, confirming the verification process.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 128,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "Can I change my email address and phone number after verification?",
    "value": "Yes, you can update your email address and phone number at any time. You will have to make a request for modification. After, you will need to re-verify the new contact information. ",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 129,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "Why do I need to provide my contact details?",
    "value": "Providing accurate contact details is essential for communication purposes. It ensures that you receive important updates, notifications, and inquiries related to your profile and bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 130,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "Is my contact information visible to others on StarClinch?",
    "value": "No, your contact information is kept private and is not visible to other users or visitors on StarClinch. It is only used for internal communication and verification purposes.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 131,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "Can I opt-out of receiving notifications and updates via email or phone?",
    "value": "Yes, you can manage your notification preferences in your account settings. You have the option to customize which types of notifications you wish to receive and how frequently you receive them.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 132,
    "name": "Contact Details",
    "slug": "contact-details",
    "content": "What should I do if I don't receive the OTP for verification?",
    "value": "If you don't receive the OTP for verification, please double-check that the email and phone number provided are correct. If the issue persists, contact our support team for further assistance.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 133,
    "name": "Social Media",
    "slug": "social-media",
    "content": "Why do I need to submit my social media URLs?",
    "value": "Submitting your social media URLs verifies your profile faster and helps StarClinch enhance it by analyzing your online reach and audience engagement. This boosts profile creation and strengthens client pitches.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 134,
    "name": "Social Media",
    "slug": "social-media",
    "content": "How does adding my social media links help with verification?",
    "value": "Providing at least one social media link during registration speeds up the profile verification process.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 135,
    "name": "Social Media",
    "slug": "social-media",
    "content": "Can I skip adding social media links during registration?",
    "value": "Yes, but providing at least one link is recommended for faster verification.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 136,
    "name": "Social Media",
    "slug": "social-media",
    "content": "What should I do after entering my social media links?",
    "value": "Click \"Submit\" to save your changes and expedite the verification process.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 137,
    "name": "Social Media",
    "slug": "social-media",
    "content": "Will my social media URLs be displayed on my profile?",
    "value": "No, they are used internally to enhance your profile and client pitches.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 138,
    "name": "Social Media",
    "slug": "social-media",
    "content": "Which platforms should I provide URLs for?",
    "value": "Provide URLs for Facebook, Instagram, and YouTube if available.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 139,
    "name": "Social Media",
    "slug": "social-media",
    "content": "How does providing social media URLs benefit me?",
    "value": "It improves your profile and helps StarClinch tailor client pitches based on your online presence.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 140,
    "name": "Social Media",
    "slug": "social-media",
    "content": "Can I update my social media URLs later?",
    "value": "Yes, update them anytime via the Social Media section in your artist dashboard.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 141,
    "name": "Social Media",
    "slug": "social-media",
    "content": "What if I don’t have profiles on all platforms?",
    "value": "You can leave blank fields for platforms you’re not active on. Providing active profiles is recommended.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 142,
    "name": "Homepage",
    "slug": "homepage",
    "content": "Are there any registration fees?",
    "value": "No, registration on StarClinch is free. You can create your artist portfolio without any upfront charges.\nWith our membership plans, you get the advantages of enjoying premium benefits like a custom-designed UI/UX for your artist website, the flexibility to choose multiple languages, and a verified badge from StarClinch. Plus, we now offer easy EMI options to make upgrading even more convenient.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 143,
    "name": "Homepage",
    "slug": "homepage",
    "content": "What kind of artists can join StarClinch?",
    "value": "We cater to a range of 14 live performers, from Singers, Bands, and DJs to Anchors, & Emcees, Comedians, and Dancers. We also welcome Magicians, Variety Artists, as well as Models & Influencers. Whether you're a solo act or part of a group, there's a place for you on StarClinch.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 144,
    "name": "Homepage",
    "slug": "homepage",
    "content": "How do I get jobs from StarClinch?",
    "value": "Once your profile is live, you become visible to thousands of potential clients. You may receive direct inquiries or offers via the platform. You can also be featured or promoted based on your performance, ratings, and response time.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 145,
    "name": "Homepage",
    "slug": "homepage",
    "content": "Can I update my portfolio after registration?",
    "value": "Yes, you can log in anytime to edit your profile, update your availability, add new photos or videos, and improve your portfolio.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 146,
    "name": "Homepage",
    "slug": "homepage",
    "content": "Do I need professional photos and videos to get listed?",
    "value": "Yes, you need to add high-quality photos and videos to let clients know your professionalism, and similarly, increase your chances of getting booked. Your website is your online stage, so make it impressive.\nAs you upgrade your membership plan, you also unlock the ability to showcase more of your work. For example, the premium Plan lets you add up to 8 images and 4 videos, while the elite Plan allows up to 10 images and 5 videos, giving your profile greater visual impact and credibility.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 147,
    "name": "Homepage",
    "slug": "homepage",
    "content": "Can I be listed in more than one category?",
    "value": "No, you cannot be listed under multiple main categories; however, you can select multiple sub-categories that reflect your event types, genres, languages, and performance style to better showcase your versatility.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 148,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "Are payments made through StarClinch secure?",
    "value": "All payments are processed securely through StarClinch. Once the event is completed and feedback is recorded, payments are released to your registered bank account.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 149,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "In how many days can I receive my payment?",
    "value": "Your payment settlement timeline depends on your membership plan. With the Free Plan, payments are processed within 30 business days. The Economy Plan reduces this to 15 days, The Premium Plan offers payouts in 7 days, and the Elite Plan ensures the fastest settlement, within just 2 business days.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 150,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "Why do I need to fill in my bank details?",
    "value": "Your bank details are required to ensure smooth and timely payments for your confirmed bookings. This allows us to transfer your earnings directly to your account without delays or manual follow-ups.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 151,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "Are my bank details safe?",
    "value": "Yes, your bank details are stored securely and used only for processing payments related to your bookings. We follow strict data protection protocols to ensure your information stays private and protected.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 152,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "Can I update my bank later?",
    "value": "To complete your portfolio to 100%, you would be required to add the required details at the time of registration. Make sure the details are accurate to avoid delays in future payments.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 153,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "What modes of payment does StarClinch use?",
    "value": "All payments on StarClinch are securely processed through Razorpay, offering you multiple convenient options, credit/debit cards, UPI, or direct bank transfers—ensuring safe and hassle-free transactions.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 154,
    "name": "Billing Details",
    "slug": "billing-details",
    "content": "Do you have EMI options?",
    "value": "Yes, with the recent introduction of EMI options, you can now subscribe to the membership plan of your choice with easy monthly payments, starting at just ₹150/month for the Economy Plan, and up to ₹703/month for the Elite Plan.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 155,
    "name": "Performance",
    "slug": "performance",
    "content": "What are the tech rider details?",
    "value": "A Tech Rider is a document that outlines all the technical requirements an artist needs for a successful performance. It is usually shared with the event organizers or the venue team before the show.\nKey requirements include audio requirements, lighting setup, stage setup, power supply, backline equipment, and sound check.\nProviding a clear, professional tech rider improves coordination and ensures a smooth performance experience.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 156,
    "name": "Performance",
    "slug": "performance",
    "content": "Why are Travel, Boarding & Lodging details important?",
    "value": "However, it is not necessary to opt for travel, boarding, and lodging; these details help organizers plan logistics, ensuring all technical setups and hospitality needs are met for a seamless performance experience. It also reflects your professionalism and preparedness.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 157,
    "name": "Performance",
    "slug": "performance",
    "content": "What happens if I leave some fields blank?",
    "value": "Your portfolio only goes live once it is 100% complete; however, you can always make changes in the required field.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 158,
    "name": "Biography",
    "slug": "biography",
    "content": "What to write in USP?",
    "value": "Your USP (Unique Selling Proposition) makes you stand out from other artists in your category. It should highlight your strengths, special skills, and value to the client.\nYour performance style (e.g., soulful Bollywood covers, high-energy DJ sets, interactive emceeing)\nExperience highlights (e.g., performed at over 200 weddings, collaborated with top brands)\nAudience appeal (e.g., great crowd engagement, perfect for destination weddings)\nAchievements (e.g., featured on MTV, shared stage with celebrity artists)\nLanguages/genres covered (e.g., Hindi, Punjabi, English, Retro, EDM)",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 159,
    "name": "Biography",
    "slug": "biography",
    "content": "How to remove plagiarism?",
    "value": "Plagiarism (copying someone else’s content) can affect your credibility and your profile’s authenticity. Here’s how you can avoid or remove it:\nWrite in your own words, share your personal journey, experiences, and unique style.\nUse plagiarism checkers like Grammarly, Quillbot, etc.\nParaphrase properly, so when you are inspired by someone else’s format, you should rephrase sentences.\nUpload your photos, performance videos, and links that reflect your actual work.\nKeeping your content original not only boosts trust but also improves visibility on platforms like StarClinch.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 160,
    "name": "Biography",
    "slug": "biography",
    "content": "How detailed should my story be?",
    "value": "Keep it concise but impactful. Share your journey, inspirations, and key milestones. A compelling story builds a personal connection and adds depth to your profile.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 161,
    "name": "Biography",
    "slug": "biography",
    "content": "Why should I add awards and achievements?",
    "value": "Awards boost your credibility and show clients your work has been recognized in the industry. Even small recognitions help build trust and attract more bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 162,
    "name": "Membership",
    "slug": "membership",
    "content": "What are StarCoins?",
    "value": "StarCoins are StarClinch’s internal virtual credits or reward points system designed to enhance user engagement and offer added benefits to artists.\nFor Artists, StarCoins can be used for:\n- Boosting profile visibility (e.g., appearing higher in search results)\n- Applying to featured job roles",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 163,
    "name": "Membership",
    "slug": "membership",
    "content": "How do artists earn StarCoins?",
    "value": "Artists can earn StarCoins by:\n- Completing your website setup\n- Buying StarCoins through our website\n- Purchasing a membership, which provides free StarCoins depending on the plan chosen.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 164,
    "name": "Membership",
    "slug": "membership",
    "content": "Can I apply for jobs without a membership?",
    "value": "Yes, you can apply for job roles without a membership; however, you would need to purchase StarCoins. Applying for a job requires a minimum of 50 StarCoins, depending on the role and its requirements.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 165,
    "name": "Membership",
    "slug": "membership",
    "content": "In how many days can I receive my payment?",
    "value": "Your payment settlement timeline depends on your membership plan.\nWith the Free Plan, payments are processed within 20 business days.\nThe Economy Plan reduces this to 15 days,\nThe Premium Plan offers payouts in 10 days,\nAnd the Elite Plan ensures the fastest settlement, within just 5 business days.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 166,
    "name": "Membership",
    "slug": "membership",
    "content": "What are the different membership plans available on StarClinch?",
    "value": "StarClinch offers three membership plans:\n- Economy – ₹2,999/year\n- Premium – ₹7,999/year\n- Elite – ₹19,999/year\nEach plan comes with increasing benefits like faster payments, more upload limits, homepage visibility, and advanced stats.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 167,
    "name": "Membership",
    "slug": "membership",
    "content": "What is the Technical Aggregation Fee (TAF)?",
    "value": "The Technical Aggregation Fee (TAF) is a small percentage deducted from your total booking amount to cover platform services such as lead generation, client coordination, and tech support. It helps maintain the infrastructure that connects artists to quality gigs.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 168,
    "name": "Membership",
    "slug": "membership",
    "content": "Why is TAF necessary?",
    "value": "TAF ensures the platform remains sustainable while continuing to provide artists with genuine bookings, personalized support, promotional tools, and secure payment processing.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 169,
    "name": "Events & Pricing",
    "slug": "events-pricing",
    "content": "What does “Regular Pricing” mean?",
    "value": "Regular Pricing refers to the base rate an artist charges for a standard 60–90 minute performance under typical conditions, including local travel and a basic setup. This price should be set based on the artist's experience, demand, location, and industry standards. It acts as a starting point for quotes and can be adjusted later depending on event-specific requirements.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 170,
    "name": "Events & Pricing",
    "slug": "events-pricing",
    "content": "What does “Special Pricing” mean?",
    "value": "Special Pricing allows artists to define custom rates for peak-demand occasions such as New Year, Holi, or Christmas. This enables flexible pricing aligned with seasonal demand, helping artists optimize their earnings for high-value dates.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 171,
    "name": "Events & Pricing",
    "slug": "events-pricing",
    "content": "Will I be bound to this price for all my bookings?",
    "value": "No. Regular and Special Pricing are just base reference points. Artists can always negotiate or quote a different price based on the event’s scale, location, travel needs, or any special requirements.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 172,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "How exactly does StarClinch function as a booking platform for dancers and dance troupes?",
    "value": "StarClinch is an online artist booking platform that connects performers — including dancers, troupes, musicians, singers, emcees, and other entertainers — with event organizers, brands, and private clients. As a dancer or troupe, your StarClinch profile becomes your digital performance portfolio, where clients can discover you by searching for terms like “Bollywood troupe”, “Sangeet dance act”, or “corporate performers”. The platform manages leads, payments, and bookings, helping you convert your talent into paid opportunities.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 173,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "Can I register on StarClinch if my experience is primarily from college events or local stage shows?",
    "value": "Yes, absolutely! Many dance artists on StarClinch began their journey performing at college fests, community gatherings, or local stage shows. What matters most is the energy, synchronization, and creativity you bring to your performances. Even a short, clear video showcasing your choreography or team coordination can attract clients. The platform gives beginners a professional presence and helps them get discovered.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 174,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "Is there an upfront charge or fee required to sign up and create an artist profile on StarClinch?",
    "value": "No, signing up is completely free. You can create your artist profile and start exploring the platform without paying anything. However, to enhance your profile visibility, access verified client leads, and appear higher in search results, many dancers upgrade to StarClinch’s paid membership plans, which work like promotional boosts for your profile.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 175,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "What are the must-have elements for a high-converting StarClinch profile as a dancer or dance group?",
    "value": "A high-converting dance profile should include:\n- Profile photo: A vibrant, confident photo of you or your troupe in costume or mid-performance.\n- Bio: A clear description of your dance style(s), group size, and the event types you perform at.\n- Performance videos: 2–3 clips with good lighting and sound — live stage videos usually work best.\n- Pricing range: Realistic starting prices (for example, solo ₹5K–₹10K; troupe ₹15K–₹40K).\n- Tags: Relevant keywords like “Bollywood”, “Folk”, “Contemporary”, “Corporate Performance”, “Wedding Dance Act”.\n- City & travel availability: Your base city and whether you can travel for events.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 176,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "Once my profile is live, what is the process for receiving and securing gigs?",
    "value": "Once your profile is approved, it becomes visible to clients searching for dance performers in your area. When someone sends an inquiry, you’ll be notified via email, SMS, or WhatsApp. You can discuss the event details, negotiate your fee, and confirm the booking through Artist Cockpit. Active profiles with recent videos, competitive pricing, and quick responses tend to receive more inquiries and secure more gigs.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 177,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "What is a realistic timeline for securing my initial booking after profile approval?",
    "value": "The timeline depends on your profile completeness and your city’s demand. Beginners who upload good-quality videos, keep their pricing flexible, and actively engage with inquiries often start getting bookings within a few weeks. Promoting your StarClinch profile on social media or sharing it directly with event organizers can speed up the process further.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 178,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "How does StarClinch provide financial security for performance fees and bookings?",
    "value": "StarClinch provides payment protection through an escrow-based system — the client pays StarClinch before the performance, and your payment is released securely after the event. This helps prevent last-minute cancellations or payment delays and makes every transaction more transparent and secure for both parties.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 179,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "Since I already use platforms like Instagram and YouTube, what is the added value of using StarClinch?",
    "value": "StarClinch complements, rather than replaces, your social media. While Instagram and YouTube showcase your creativity and help you build an audience, StarClinch acts as your professional booking gateway. You can link your social accounts, upload videos here, and share your StarClinch profile link in your bio — helping you convert followers and viewers into paying clients and confirmed bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 180,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "What are the most effective techniques to differentiate my profile and performance style from the competition?",
    "value": "To stand out from other dancers and troupes:\n- Craft a powerful bio that highlights your dance style, journey, and performance experience.\n- Upload professional-looking videos — even 30-second clips with stage lighting and crowd reactions work well.\n- Update your portfolio regularly with new photos, costumes, and concepts.\n- Encourage clients to leave positive reviews, as they directly improve your search ranking.\n- Respond promptly to inquiries — higher response rates are favored by StarClinch’s system and by clients.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 181,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "If I am experiencing a lack of booking inquiries, what immediate steps should I take to improve my visibility?",
    "value": "If inquiries are low, you can:\n- Refresh your videos and photos regularly — strong first impressions matter.\n- Use trending and relevant tags like “Sangeet Performers”, “Hip-Hop Crew”, or “Fusion Dance Act”.\n- Keep your pricing flexible initially until you build a base of reviews.\n- Share your StarClinch profile link in local WhatsApp groups and with wedding or event planners.\n- Consider upgrading to a membership plan for better visibility and access to more leads.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 182,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "What is the range of event types for which dancers and troupes are typically booked via the platform?",
    "value": "Dancers and troupes on StarClinch are typically booked for:\n- Private events: Weddings, engagements, birthdays, and anniversaries.\n- Corporate shows: Annual functions, brand activations, and product launches.\n- Stage performances: College fests, cultural programs, and live concerts.\n- Theme-based acts: Bollywood medleys, folk fusions, flash mobs, and customized routines.\nThe types of gigs you receive depend on your dance genre, group size, and how well your profile, content, and pricing are presented.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 183,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "Is there a market for solo dancers or beginner-level troupes among the clients using StarClinch?",
    "value": "Yes, there is a strong market for both solo dancers and beginner-level troupes. Clients often look for fresh, energetic performers for smaller-scale or budget-friendly events. If your videos reflect good choreography, energy, and audience connection, you can still secure your first few gigs even without a long performance history.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 184,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "Am I allowed to negotiate the quoted prices for my performance based on client requirements or event scale?",
    "value": "Yes, you can absolutely negotiate your pricing. Quote your fee based on the number of dancers, performance duration, choreography complexity, rehearsal time, and travel or stay requirements. Start with competitive rates — once you establish credibility and collect positive reviews, you can gradually increase your pricing to reflect your growing demand and experience.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 185,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "How should I professionally address and respond to low ratings or critical client feedback?",
    "value": "Treat negative or critical feedback as a chance to improve. Respond politely, thank the client for sharing their experience, and ask what could have been better. Implement those learnings in your future performances and communication. Over time, consistent professionalism, better preparation, and stronger content will outweigh occasional low ratings. Positive reviews from satisfied clients will become your biggest asset on the platform.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 186,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "What steps are essential for building and scaling a recognizable personal or troupe brand via the platform?",
    "value": "To build a strong, recognizable brand as a dancer or troupe:\n- Maintain brand consistency — use the same logo, color palette, and name across all platforms.\n- Upload a highlight reel that captures your best moments, costume quality, and audience engagement.\n- Add testimonials and reviews from past clients to your profile.\n- Collaborate with singers, emcees, or event planners on StarClinch to expand your reach.\n- Include achievements, awards, or press mentions in your bio to increase credibility.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 187,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "How can I ensure repeat bookings and foster ongoing, long-term partnerships with event planners?",
    "value": "Repeat bookings come from reliability and memorable performances. Be punctual, professional, and easy to coordinate with before and during events. Communicate clearly about requirements, arrive prepared, and deliver high-energy, engaging shows. After a successful event, stay in touch with planners and clients, share your updated work, and let them know you’re available for future dates. Over time, you’ll build long-term partnerships and strong word-of-mouth referrals.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 188,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "Should I rely only on StarClinch for gigs?",
    "value": "No, you should treat StarClinch as your primary professional booking platform, but not your only source of gigs. Combine it with:\n- Live performances at open events, dance battles, and festivals.\n- Instagram Reels or YouTube Shorts to showcase your choreography and style.\n- Collaborations with photographers, musicians, and other local artists.\nA mix of online visibility and offline networking creates a stronger, more sustainable flow of opportunities.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 189,
    "name": "Dancers & Dance Troupes",
    "slug": "dancers-dance-troupes",
    "content": "What are the most common mistakes dancers make on StarClinch?",
    "value": "Some common mistakes dancers and troupes make on the platform include:\n- Uploading low-quality, shaky, or outdated performance videos.\n- Setting unrealistic prices without reviews or sufficient proof of work.\n- Ignoring inquiries or replying too late to interested clients.\n- Failing to specify dance genres, troupe size, or event types clearly.\n- Expecting instant gigs without regularly updating content or promoting their profile.\nStarClinch amplifies your reach, but consistent effort, clear communication, and professional presentation are what convert that reach into real success.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 190,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "What is Express Booking on StarClinch?",
    "value": "Express Booking is a fast-track feature that connects you with high-intent clients who are ready to book quickly. Instead of long negotiation cycles, you receive direct booking opportunities with faster turnaround and higher conversion potential.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 191,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "How is Express Booking different from regular leads?",
    "value": "Unlike standard inquiries, Express Booking leads come from users who have already shared detailed requirements and are closer to making a payment. This means less back-and-forth and more confirmed gigs.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 192,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "How do I get access to Express Booking leads?",
    "value": "Express Booking is available to selected artists, primarily those with optimized profiles. You may need to upgrade or maintain a strong profile performance for confirmed bookings.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 193,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "How will I receive Express Booking requests?",
    "value": "All Express Booking opportunities are visible directly in your Artist Cockpit. You’ll also receive notifications so you can respond quickly and increase your chances of getting booked.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 194,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "Do I need to respond faster to Express Booking leads?",
    "value": "Yes. Speed is critical. These leads are shared with a limited number of artists, and quicker responses significantly improve your chances of getting confirmed.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 195,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "Is pricing fixed in Express Booking?",
    "value": "In most cases, the client has a defined budget range. You can accept or decline within that range depending on your availability and interest.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 196,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "Will Express Booking improve my chances of getting gigs?",
    "value": "Absolutely. Since these leads are high-intent and closer to payment, artists typically see better conversion rates compared to standard inquiries.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 197,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "Does Express Booking affect my profile ranking?",
    "value": "Yes. Actively engaging with Express Booking leads (quick responses, higher acceptance, successful bookings) can positively impact your visibility and ranking on StarClinch.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 198,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "Can I choose which Express Booking requests to accept?",
    "value": "Yes. You have full control to accept or decline requests based on your availability, pricing, and event preferences.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 199,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "What happens after I accept an Express Booking request?",
    "value": "Once you accept, the client may choose to accept or reject your profile. After confirmation, the booking is locked, and further event coordination can begin.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 200,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "Are Express Booking leads shared with multiple artists?",
    "value": "Yes, but with a limited and curated set of relevant artists. This ensures fair competition while keeping your chances of selection high.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 201,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "How can I increase my chances of getting selected in Express Booking?",
    "value": "Keep your profile updated with strong event videos\nRespond instantly to requests\nMaintain competitive pricing\nBuild a strong track record with good reviews and completed gigs",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 202,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "How can I enable and start receiving Express Booking?",
    "value": "To start receiving Express Booking opportunities, you need to accept the Express Booking consent from your Artist Cockpit. Once enabled, your profile becomes eligible for high-intent booking requests.\nYou can review all details, terms, and activation steps here.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  },
  {
    "id": 203,
    "name": "Express Booking",
    "slug": "express-booking",
    "content": "Can I disable Express Booking after enabling it?",
    "value": "Yes, you can manage your participation anytime from your Express Booking settings, depending on your availability and preferences.",
    "created_at": "2024-12-30 09:03:10.730497",
    "updated_at": "2024-12-30 09:03:10.730497"
  }


  
];

/**
 * Group FAQs by category
 */
export const getFAQsByCategory = (faqs: FAQ[]): Record<string, FAQ[]> => {
  return faqs.reduce((acc, faq) => {
    const category = faq.name;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(faq);
    return acc;
  }, {} as Record<string, FAQ[]>);
};

/**
 * Get all unique categories
 */
export const getCategories = (faqs: FAQ[]): string[] => {
  return Array.from(new Set(faqs.map(faq => faq.name)));
};
